import React, { memo, useCallback, useState } from 'react';

import { TenderTypeNames, TenderTypes } from '@app/models';
import { ExpandableForm } from '@app/common';
import Panel1Img from './1.svg';
import Panel2Img from './2.svg';

interface Props {
  defaultExpanded: boolean;
  value: TenderTypes | null;
  onSubmit: (tenderType: TenderTypes, isSubmit: boolean) => void;
}

function TenderTypeForm(props: Props) {
  const { defaultExpanded, value, onSubmit } = props;
  const [expanded, setExpanded] = useState<boolean>(defaultExpanded);
  const [checkedItem, setCheckedItem] = useState(0);

  const onChange = useCallback(
    (tenderType: TenderTypes) => () => {
      setCheckedItem(tenderType);
      onSubmit(tenderType, false);
    },
    [onSubmit]
  );

  const onChangeSwitch = useCallback(() => {
    setExpanded(!expanded);
  }, [expanded]);

  const onSubmitForm = useCallback(
    (e: React.FormEvent<HTMLFormElement>) => {
      e.preventDefault();
      e.stopPropagation();

      setExpanded(false);
      onSubmit(value as TenderTypes, true);
    },
    [onSubmit, value]
  );

  return (
    <ExpandableForm
      submitLabel="Далее"
      title="Выберите тип объявления"
      onSubmit={onSubmitForm}
      description={value ? TenderTypeNames[value] : ''}
      expanded={expanded}
      disableSwitcher={true}
      onChangeSwitch={onChangeSwitch}
      disabled={!value || !expanded}
    >
      <div className="flex gap-2 items-center md:flex-row flex-col">
        <div
          className={`p-2 w-[192px] bg-[#f5f5f5] rounded-[10.6px] hover:cursor-pointer hover:border-2 hover:border-primary hover:p-1 ${
            checkedItem === TenderTypes.OFFER
              ? 'border-2 border-primary p-1'
              : ''
          }`}
          onClick={onChange(TenderTypes.OFFER)}
        >
          <p>Предлагаю</p>
          <div>
            <img src={Panel1Img} alt={TenderTypeNames[TenderTypes.OFFER]} />
          </div>
        </div>
        <div
          className={`p-2 w-[192px] bg-[#f5f5f5] rounded-[10.6px] hover:cursor-pointer hover:border-2 hover:border-primary hover:p-1 ${
            checkedItem === TenderTypes.REQUEST
              ? 'border-2 border-primary p-1'
              : ''
          }`}
          onClick={onChange(TenderTypes.REQUEST)}
        >
          <p>Ищу</p>
          <div>
            <img src={Panel2Img} alt={TenderTypeNames[TenderTypes.REQUEST]} />
          </div>
        </div>
      </div>
    </ExpandableForm>
  );
}

export default memo(TenderTypeForm);
